import React from 'react';
import cx from 'classnames';

import { ClickAwayListener, Popper } from '@lyearn/ui';

import AddMenuItems from '../../components/Menu/AddMenuItems';
import { addMenu } from './style';
import { AddMenuProps } from './types';

function AddMenu(props: AddMenuProps) {
  const {
    blocksMap,
    onClick,
    open,
    placement,
    anchorEl,
    popperOptions,
    selectedMenuItemIndex,
    menuRef,
    onClose,
    isMicroLearning,
  } = props;

  return (
    <ClickAwayListener mouseEvent="onMouseUp" onClickAway={onClose}>
      <Popper
        ref={menuRef}
        anchorEl={anchorEl}
        className={cx('mt-8 rounded-8 border border-divider bg-bg-primary shadow-01', addMenu)}
        dir={document.dir}
        open={open}
        placement={placement}
        popperOptions={popperOptions}>
        <AddMenuItems
          blocksMap={blocksMap}
          selectedMenuItemIndex={selectedMenuItemIndex}
          onClick={onClick}
        />
      </Popper>
    </ClickAwayListener>
  );
}

export default AddMenu;
